<template>
  <b-table class="mt-2" striped hover :fields="fields" :items="rows">
  </b-table>
</template>

<script>
import articles from '@/modules/articles.js'

export default {
  name: 'ArticleText',
  props: ["descid"],
  data() {
    return {
      fields: [
        {label:"ID",key:"map_id"},
        {label:"Sprache",key:"lang"},
        {label:"Kennung",key:"label"},
        {label:"Name",key:"short_des"},
        {label:"Beschreibung",key:"des"},
      ],
      rows: []
    }
  },
  watch: {
    descid: function() { console.log('watch:' + this.descid); this.fetchData(); }
  },
  methods: {
    fetchData: function() {
      var self = this;
      articles.loadtext(this.descid,function(data) {
        self.rows = data;
      })
    }
  }
}
</script>
